export * from './arquivosupload.service';
export * from './auditor.service';
export * from './auditoria.service';
export * from './autenticacao.service';
export * from './auth-guard.service';
export * from './caixaentrada.service';
export * from './certificado.service';
export * from './cnpj.pipe';
export * from './cpf.pipe';
export * from './email.service';
export * from './encontro-tecnico.service';
export * from './event-emitter.service';
export * from './azure-storage.service';
export * from './fornecedor.service';
export * from './logerro.service';
export * from './mantenedora.service';
export * from './menu.service';
export * from './notificacao.service';
export * from './pdf.service';
export * from './planilha.service';
export * from './perfil.service';
export * from './reuniao-ce.service';
export * from './reuniao-gt.service';
export * from './satisfacao.service';
export * from './sga.auth.interceptor.service';
export * from './sistemagestao.service';
export * from './solicitacao.service';
export * from './tabelasAuxiliares.service';
export * from './usuario.service';
export * from './util.service';
export * from './workflow.service';
export * from './indicativos.service';
export * from './relatorios.service';
export * from './exportCSV.service';



// WEBPACK FOOTER //
// /app/src/app/services/index.ts